import Vue from "vue";
import moment from "moment";

Vue.filter("formatNumber", (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});

Vue.filter("formatDate", (date) => {
    return moment(date).format("MMM D, YYYY");
})